import styled from 'styled-components'

export const Container = styled.section`
    float: left;
    width: 100%;
    position: relative;
    background-color: #1A1B59;
    padding: 70px 60px;
    display: flex;
    justify-content: center;
    border-bottom: solid 5px #202156;

    @media (max-width: 1000px) {
        padding: 40px 20px;
    }
`

export const ContainerInterno = styled.div`
    display: inline-block;
    width: 100%;
    max-width: 1436px;
    display: flex;
    align-items: center;
`

export const Texto = styled.span`
    float: left;
    width: 100%;
    text-align: center;
    background: linear-gradient(90deg,rgba(189, 137, 59, 1) 0%, rgba(239, 189, 94, 1) 100%);
    border-radius: 20px;
    padding: 30px;
    font-size: 30px;
    line-height: 40px;
    color: #1A1206;
    font-weight: 900;

    @media only screen and (max-width: 1500px) {
        font-size: 30px;
        line-height: 34px;
    }

    @media only screen and (max-width: 1000px) {
        font-size: 18px;
        line-height: 28px;
    }
`